import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, AfterViewInit } from '@angular/core';
// import { Telematics } from './../../../shared/models/telematics.model';
import { Router } from '@angular/router';
import * as util from './../../../shared/services/util.service';
import { DateTime } from 'luxon';
import { Store } from '@ngrx/store';
// import { EditServiceAppointmentFromDashboard } from '../../store/service-appointment/service-appointment.actions';
// import { ServiceAppointmentState } from '../../store/service-appointment/service-appointment.reducer';
import { selectIsBeingCancelledByAppointmentId } from './../../../store/bdcdashboard/bdcdashboard.selectors';
import { BdcDashboardState } from './../../../store/bdcdashboard/bdcdashboard.reducer';
import { Observable } from 'rxjs';
import { SubscriptionList } from './../../../shared/models/asp.types';
import { AppointmentBookingSource, Department, LocationType } from '@signal/asp-data-commons';
import {EditServiceAppointmentFromDashboard} from '../../../store/service-appointment/service-appointment.actions';
import {ServiceAppointmentState} from '../../../store/service-appointment/service-appointment.reducer';
import {VehicleService} from '../../../shared/services/vehicle.service';
import {Telematics} from '../../../shared/models/telematics.model';
import { TranslateService } from '@ngx-translate/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { DealerState } from './../../../store/dealer/dealer.reducer';
import * as fromSelectors from './../../../store/dealer/dealer.selectors';
import { register } from 'swiper/element/bundle';

@Component({
  selector: 'app-service-card',
  templateUrl: './service-card.component.html',
  styleUrls: ['./service-card.component.scss'],
})
export class ServiceCardComponent implements OnInit, OnDestroy, AfterViewInit  {
  /* vehicle info to be displayed in the card */
  @Input() vehicle: any;
  @Input() isOwnedVehicle: boolean;
  @Output() appointmentCancel: EventEmitter<number> = new EventEmitter<number>();

  telematics: Telematics;
  setDefaultImg=util.setDefaultImg;
  vinDisplayText: string;
  model:string;
  makeModelYearText: string;
  appointmentExists: boolean;
  appointmentDateTime: string;
  carImageAbsoluteURL: string;
  dealerName: string;
  dealerPhone: string;
  appointmentLocationType: string;
  appointmentLocationAddress: string;
  appointmentsCount : number;
  signedIn: boolean;
  index : number = 0;
  isFlipCard = false;
  flipCancelCard = false;
  isAppointmentFlipCard : boolean = false;
  flipTo = '';
  isTelematicsLoading = true;
  countryCd: string = util.countryCd;
  dealerCode$: Observable<string>;

  disclaimerText: string;
  isBeingCancelled$: Observable<boolean>;

  public config = {
      a11y: {
      enabled: true,
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      },
      direction: 'horizontal',
      slidesPerView: 1,
      keyboard: { 
          enabled: true,
          onlyInViewport: false,
          pageUpDown: true
        },
      mousewheel: { 
          enabled: true,
          forceToAxis: true
        },
      scrollbar: {
          enabled: true,
          el: '.swiper-scrollbar',
          draggable: true,
          hide: false
        },
      navigation: {
          enabled: true
        },
      pagination: {
          enabled: true,
        clickable: true,
        hideOnClick: false,
      type: "bullets"
    },
    };
  private subs: SubscriptionList = {};

  constructor(
    private readonly router: Router,
    private readonly vehicleService: VehicleService,
    private readonly dashboardState: Store<BdcDashboardState>,
    private readonly serviceAppointmentState: Store<ServiceAppointmentState>,
    private readonly translate: TranslateService,
    private readonly copy: Clipboard,
    private readonly dealerState: Store<DealerState>
  ) {
    this.dealerCode$ = this.dealerState.select(fromSelectors.selectDealerCode);
    this.disclaimerText = util.GLOBAL_CONSTANT.telematicsDisclaimerText;
    //this.signedIn = !!this.authService.getAccount();

  }

  ngOnInit(): void {
    this.vinDisplayText = `VIN ${this.vehicle.vin || this.translate.instant('service.notAvailable')}`
    this.makeModelYearText = util.getMakeModelYearText(this.vehicle);
    this.appointmentExists = this.vehicle.appointment?.length > 0 || false;
    this.appointmentDateTime = this.appointmentExists ? this.getAppointmentDateTime() : '';
    this.dealerName = this.vehicle.dealer?.dealerName;
    this.dealerPhone = this.vehicle.dealer?.phoneNumber;
    this.appointmentsCount = this.vehicle.appointment?.length || 0;
    const index= this.vehicle.description?.indexOf(" ");
    this.model=this.vehicle.description?.substr(index);
    this.getLocationType();

    // TODO - Store generic image URL in prop/env
    this.carImageAbsoluteURL = util.getCarImageAbsoluteURL(this.vehicle.imageUrl);
    if (this.vehicle.appointment && this.vehicle.appointment[this.index]) {
      const props = { appointmentId: this.vehicle.appointment[this.index].appointmentId };
      this.isBeingCancelled$ = this.dashboardState.select(selectIsBeingCancelledByAppointmentId, props);
    }

    this.fetchTelematics();
  }

  ngAfterViewInit() {
    register();
  }

  getTelematicsAlerts() {
    return this.telematics.alerts;
  }

  shouldEnableLoop() {
    return this.telematics?.alerts && this.telematics.alerts.length > 2;
  }

  doFlipCard() {
    this.flipTo = 'issue';
    this.isFlipCard = !this.isFlipCard;
  }

  onCancelFlip() {
    this.flipTo = this.appointmentsCount === 1 ? '' : 'all-appointments';
    this.isFlipCard = false;
    if(this.appointmentsCount !== 1){
      setTimeout(() => {
        this.isFlipCard = true;
      }, 250);
    }
  }

  onCancelAppointment(){
    this.flipTo = "cancel";
    this.isFlipCard = false;
    setTimeout(() => {
      this.isFlipCard = true;
    }, 250);
  }

  cancelAppointmentFlip(){
    this.flipTo = "";
    this.isFlipCard = false;
  }

  onCancel() {
    this.appointmentCancel.emit(this.index);
  }

  onEditAppointment() {
    const payload = {
      id: this.vehicle.appointment[this.index].appointmentId,
    };
    const navigateUrl = 'asp/bdc/service';
    this.serviceAppointmentState.dispatch(new EditServiceAppointmentFromDashboard());
    this.router.navigate([navigateUrl], { queryParams: payload });
  }

  onCreateAppointment() {
    const navigateUrl = 'asp/bdc/service';
    if(this.vehicle.vin){
      this.router.navigate([navigateUrl],
     { queryParams: { vin: this.vehicle.vin, selectedVehicle:true } });
    }else{
      this.router.navigate([navigateUrl],
      { queryParams: { make: this.vehicle.make , model : this.vehicle.model , year : this.vehicle.year?.toString() , selectedVehicle:true } });
    }

  }

  onCreateLearningAppointment() {
    const navigateUrl = 'asp/bdc/tech-appointment';
    if(this.vehicle.vin){
      this.router.navigate([navigateUrl],
     { queryParams: { vin: this.vehicle.vin, selectedVehicle:true } });
    }else{
      this.router.navigate([navigateUrl],
      { queryParams: { make: this.vehicle.make , model : this.vehicle.model , year : this.vehicle.year?.toString() , selectedVehicle:true } });
    }
  }

  getEditBtnText() {
    let apptType = this.vehicle.appointment[this.index].appointmentType ? `${this.vehicle.appointment[this.index].appointmentType}` : ' ';
    apptType = apptType?.replace(' ','');
    return apptType ?`testDrive.edit${apptType}Appointment`: `testDrive.editAppointment`;
  }

  getEditCancelBtnText() {
    let apptType = this.vehicle.appointment[this.index].appointmentType ? `${this.vehicle.appointment[this.index].appointmentType}` : ' ';
    apptType = apptType?.replace(' ','');
    return apptType ?`testDrive.editcancel${apptType}Appointment`: `testDrive.editcancelAppointment`;
  }

  getAppointmentDateTime(): string {
    return DateTime.fromISO(this.vehicle.appointment[this.index].appointmentStartDate).toFormat('MMM dd') + ' at ' + this.vehicle.appointment[this.index].timeSlotId;
  }

  seeAllAppointmentsBtnText(){
    return `${this.translate.instant('testDrive.seeAllAppointments')} (${this.appointmentsCount})`
  }

  seeAllApppointments(){
    this.flipTo = "all-appointments";
    this.isAppointmentFlipCard = !this.isAppointmentFlipCard;
    this.isFlipCard = true;
  }

  onEditCancelAppointment(){
    this.flipTo = "editcancel-appointments";
    this.isAppointmentFlipCard = !this.isAppointmentFlipCard;
    this.isFlipCard = true;
  }

  ngOnDestroy(): void {
    util.unsubscribeSubscriptions(this.subs);
  }

  getDealerAddress() {
    if (this.appointmentLocationType) {
      if (LocationType.DEALER === this.appointmentLocationType) {
        const dealer = this.vehicle.appointment[this.index].dealer;
        this.appointmentLocationAddress = `${dealer.address.addressLine1}, ${dealer.address.city}, ${dealer.address.state} ${dealer.address.zip}`;
      } else {
        const customer = this.vehicle.appointment[this.index].pickUpAddress ? this.vehicle.appointment[this.index].pickUpAddress : this.vehicle.appointment[this.index].customer.address;
        this.appointmentLocationAddress = customer.addressLine1 + ', ' + (customer.addressLine2 ? customer.addressLine2 +
          ', ' : '') + customer.city + ', ' + customer.state + ' - ' + customer.zip;
      }
    }
  }

  getLocationType() {
    if (this.vehicle.appointment && this.vehicle.appointment[this.index]) {
      this.appointmentLocationType = this.vehicle.appointment[this.index].transportation.category;
      this.getDealerAddress();
    }
  }

  onNavigateToGmap() {
    if (this.vehicle.appointment[this.index].dealer && this.isAtDealership) {
      const link = `https://www.google.com/maps?z=12&t=m&q=loc:${this.vehicle.appointment[this.index].dealer.latitude}+${this.vehicle.appointment[this.index].dealer.longitude}`;
      this.router.navigate([]).then(result => {
        window.open(link, '_blank');
      });
    }
  }

  get isAtDealership(){
    return this.appointmentLocationType === LocationType.DEALER;
  }

  private fetchTelematics() {
    if (!this.vehicle.vin) {
      return;
    }

    this.isTelematicsLoading = true;
    this.subs.telematics = this.vehicleService.getTelematics(this.vehicle.vin,Department.SERVICE)
      .subscribe(data => {
        if (data.status.code === 200) {
          this.telematics = Telematics.getTelematics(data?.data);
        } else {
          this.telematics = Telematics.getDefaultTelematics();
        }
        this.isTelematicsLoading = false;
      }, err => {
        this.telematics = Telematics.getDefaultTelematics();
        this.isTelematicsLoading = false;
      });
  }

  onHistoryClicked() {
    this.router.navigate(['asp/bdc/dashboard/servicehistory'], {
      queryParams: {
        vin: this.vehicle.vin
      }
    });
  }

  onCopyDetails() {
    this.copy.copy(this.convertToText());
  }

  convertToText() {
    let text = '';
    text += `${util.getMakeModelYearText(this.vehicle)}\n`;
    text += `VIN ${this.vehicle.vin || this.translate.instant('service.notAvailable')}`;
    if (this.vehicle.appointment) {
      text += `\n${this.translate.instant('testDrive.serviceAppointmentIsScheduledFor')} ${this.appointmentDateTime}`;
      text += `\n${this.getTranslation(this.appointmentLocationType)}: ${this.appointmentLocationAddress}`;
    }
    return text;
  }

  incrementIndex(){
    if(this.index<this.appointmentsCount-1){
      this.index += 1;
    }
    this.getLocationType();
  }

  decrementIndex(){
    if(this.index > 0){
      this.index-=1;
    }
    this.getLocationType();
  }
  getTitle(key:string,value){
    if(key === 'ppmEligible'){
      return this.translate.instant('service.customerIsEligibleForProtectionProducts');
    }
    if(key === 'protectionProducts'){
      return `${this.translate.instant('service.protectionProducts')} : ${value === undefined ? this.translate.instant('testDrive.notAvailable') :value.length > 0 ? value :'NA'}`
    }
  }
  checkSignalDataAvailable(){
    const protectionProductsData = [];
    if(this.vehicleService.selectedCustomerTelematicsDetails.length > 0 ){
      this.vehicleService.selectedCustomerTelematicsDetails.forEach(tele => {
        const telematics = tele.telematicsData.data;
        if((telematics.protectionProducts?.protectionProductAvailableScore !== undefined
          && (telematics.protectionProducts?.protectionProductAvailableScore > 0))
           || (telematics.protectionProducts?.protectionProducts 
             && telematics.protectionProducts?.protectionProducts !== undefined 
             && telematics.protectionProducts?.protectionProducts?.length > 0)){
              protectionProductsData.push(true);
             }
      });
      const value = protectionProductsData.some(data => data === true);
      if (value) {
        return true;
      }
      else {
        return false;
      }
    }
    return false;
  }
  getAlert(alert){
    const alertArray = alert.split(' ');
    const alertValue = alertArray[0].toLowerCase()+alertArray[1];
    if(alertArray[0].match(/^[A-Za-z]+$/)){
     return this.translate.instant(`service.${alertValue}`);
    }else{
      return `${alertArray[0]} ${this.translate.instant(`service.${alertArray[1].toLowerCase()}`)}`
    }
  }
  getTranslation(appointmentLocationType){
    const value = appointmentLocationType ? appointmentLocationType.replace(' ','') :appointmentLocationType;
    return value ? this.translate.instant(`service.${value.toLowerCase()}`) : appointmentLocationType;
  }
  getTelematicsTranslation(value){
    if(value ){
      const translatedTxt = value.split(':');
      return this.translate.instant(`${translatedTxt[0]}`) +(translatedTxt[1]==='(Not available)' ? `(${this.translate.instant(`testDrive.notAvailable`)})` : translatedTxt[1]);
    }
  }
  isLexusDealer(dealerCode: string): boolean {
    return !!dealerCode?.toString().startsWith('6');
  }

  isServiceButtonDisable() {
    return !util.isServiceAccessibleFeatureFlag ?  !!util.isSpServiceDashboardOverride : false;
  }

  isMyKarmaAppointment(): boolean {
    return this.vehicle.appointment[this.index]?.appointmentBookingSource === AppointmentBookingSource.MYKARMA;
  }

  isServiceAccessibleForBtn(){
    return util.isServiceAccessibleFeatureFlag;
  }

  isSalesAccessibleForBtn(){
    return util.isSalesAccessibleFeatureFlag;
  }
}
